import type { LeDataContentBlock } from '~/types/leData';
import type { LensCard } from '~/types/leLens';

type ReceiptMessage = { blocks?: ReadonlyArray<LeDataContentBlock> };

export function latestCreatedReceiptId(messages: ReadonlyArray<ReceiptMessage>): string | null {
  for (let messageIndex = messages.length - 1; messageIndex >= 0; messageIndex -= 1) {
    const blocks = messages[messageIndex].blocks ?? [];
    for (let blockIndex = blocks.length - 1; blockIndex >= 0; blockIndex -= 1) {
      if (blocks[blockIndex].type === 'lens_created') return blocks[blockIndex].id;
    }
  }
  return null;
}

export function createdReceiptLensId(block: LeDataContentBlock, latestId: string | null): string | null {
  if (block.type !== 'lens_created' || block.id !== latestId) return null;
  const { lensId } = block.payload as Record<string, unknown>;
  return typeof lensId === 'string' ? lensId : null;
}

export function unboundCards(cards: ReadonlyArray<LensCard>): Array<LensCard> {
  return cards.filter((card) => card.refusal || (!card.datasetId && card.type !== 'insight'));
}
